import React, { Fragment } from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import BrandCreateGlobal from '../../brand/Brand.create.global';

function ProductBrandModal({ show, onHide }) {

    return (
        <Modal centered dialogClassName="modal-container" show={show} onHide={onHide} size="md" animation={true}>
            <Modal.Header closeButton> <Modal.Title>Brand</Modal.Title> </Modal.Header>
            <Modal.Body>
                <BrandCreateGlobal pageOrigin="item"/>
            </Modal.Body>
        </Modal>
    )
}

const mapStateToProps = state => ({
	// brand: state.brand
});

export default connect(mapStateToProps, {})(ProductBrandModal);
